export const CurrentPage = {
  DATA_COLLECTION: 'DATA_COLLECTION',
  DATAFLOW_DASHBOARDS: 'DATAFLOW_DASHBOARDS',
  DATAFLOW_FEEDBACK: 'DATAFLOW_FEEDBACK',
  DATAFLOW_HELP: 'DATAFLOW_HELP',
  DATAFLOW_REFERENCE_DATASET: 'DATAFLOW_REFERENCE_DATASET',
  DATAFLOW: 'DATAFLOW',
  DATAFLOWS: 'DATAFLOWS',
  DATASET_DESIGNER: 'DATASET_DESIGNER',
  DATASET: 'DATASET',
  EU_DATASET: 'EU_DATASET',
  PUBLIC_COUNTRIES: 'PUBLIC_COUNTRIES',
  PUBLIC_COUNTRY: 'PUBLIC_COUNTRY',
  PUBLIC_DATAFLOW: 'PUBLIC_DATAFLOW',
  PUBLIC_DATAFLOWS: 'PUBLIC_DATAFLOWS',
  PUBLIC_INDEX: 'PUBLIC_INDEX',
  REFERENCE_DATAFLOW: 'REFERENCE_DATAFLOW',
  REFERENCE_DATASET_DESIGNER: 'REFERENCE_DATASET_DESIGNER',
  REFERENCE_DATASET: 'REFERENCE_DATASET',
  TEST_DATASETS: 'TEST_DATASETS',
  USER_SETTINGS: 'USER_SETTINGS'
};
